import React from "react";
import { Card } from "react-bootstrap";
export default class SmallBanner extends React.PureComponent {
    render() {
        const { title, htmlContent, link, imageUrl, className } = this.props;
        return (React.createElement(Card, { className: className + " small-banner__background", style: { backgroundImage: `url(${imageUrl})` } },
            React.createElement(Card.Body, null,
                title && React.createElement("h2", { className: "display-2 mb-3 text-white" }, title),
                React.createElement("div", { className: "small-banner_text mb-4", dangerouslySetInnerHTML: { __html: htmlContent } }),
                link)));
    }
}
//# sourceMappingURL=index.js.map